import React from 'react';
import CrudPage from '../../components/CrudPage';
import { contactUsApi } from '../../services/adminApi';

const columns = [
  { header: 'ID', field: 'contactId' },
  { header: 'Name', field: 'name' },
  { header: 'Email', field: 'email' },
  { header: 'Subject', field: 'subject' },
  { header: 'Message', field: 'message' },
  { header: 'Created', field: 'createdAt', type: 'date' },
];

const ContactUsPage = () => (
  <CrudPage
    title="Contact Us"
    subtitle="View contact form submissions (read-only)"
    api={contactUsApi}
    columns={columns}
    formFields={[]}
    idField="contactId"
    searchField="name"
    disableCreate={true}
    disableEdit={true}
    disableDelete={true}
  />
);

export default ContactUsPage;
